module.exports = __webpack_public_path__ + "media/assets/images/logos/verdikt-logo-motto-bf0dbf0b66922787f27763f422a9b9ad.png";